import { fetch } from '../fetchWrapper/fetch';
import { IRange, IRangesResponseBody } from './types';
import { API_URL } from '../constants';

export const getRanges = async (): Promise<IRange[]> => {
  try {
    const res = await fetch(`${API_URL}/ranges`);

    if (!res.ok) throw new Error();

    const { data }: IRangesResponseBody = await res.json();
    return data;
  } catch (e) {
    throw new Error('Could not fetch ranges');
  }
};
